import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Workspace from "@/pages/Workspace";
import AuditPage from "@/pages/AuditPage";
import UsersPage from "@/pages/UsersPage";
import Settings from "@/pages/Settings";
import { Loader2 } from "lucide-react";

function Protected({ children, adminOnly }) {
  const { user, loading } = useAuth();
  const path = window.location.pathname;
  if (loading)
    return (
      <div className="flex h-screen items-center justify-center text-slate-500">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && path !== "/change-password")
    return <Navigate to="/change-password" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/change-password" element={<Protected><ChangePassword /></Protected>} />
            <Route path="/" element={<Protected><Workspace /></Protected>} />
            <Route path="/history" element={<Protected><AuditPage /></Protected>} />
            <Route path="/users" element={<Protected adminOnly><UsersPage /></Protected>} />
            <Route path="/settings" element={<Protected adminOnly><Settings /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
